import React, { useState, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import Locations, {
  AddressValue,
} from '../../../ReportBuilder/Components/Location/Locations';
import { parseAddressValue } from '../../../ReportBuilder/Components/Location/SectionLocation';
import { getTotalPercentage } from '../../../ReportBuilder/Components/Location/utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

const StyledDiv = styled.div`
  .location-search-field {
    background-color: ${COLORS.whiteBase};
  }
  .content-wrapper {
    background-color: ${COLORS.whiteBase};
  }
`;

const LocationSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(({ reportId, questionId, questionText, answer }, forwardRef) => {
  const [addresses, setAddresses] = useState<AddressValue[]>(
    parseAddressValue(answer),
  );

  useImperativeHandle(forwardRef, () => ({
    reportId,
    questionId,
    answer: () =>
      getTotalPercentage(addresses) === 100 ? JSON.stringify(addresses) : '',
    errorText: () =>
      getTotalPercentage(addresses) === 100
        ? undefined
        : 'Total percentage must be added to 100.',
  }));

  return (
    <StyledDiv>
      <TrueImpactText variant="heading-subheading" className="question-text">
        Where does your program operate?
      </TrueImpactText>
      <Locations addresses={addresses} onChange={setAddresses} />
    </StyledDiv>
  );
});

export default LocationSection;
